import { useCallback, useEffect } from 'react';

import { usePopupGroupContext } from '@/scenarios/legacy-player/components/PlayerSkin/parts/PopupGroup';

interface Params {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    onClick?: () => void;
}

export const usePlayerPopupButton = ({ isOpen, setIsOpen, onClick }: Params) => {
    const [popupVisible] = usePopupGroupContext(isOpen);

    useEffect(() => {
        if (!popupVisible) {
            setIsOpen(false);
        }
    }, [popupVisible, setIsOpen]);

    const handleClick = useCallback(() => {
        setIsOpen(!isOpen);
        onClick?.();
    }, [isOpen, onClick, setIsOpen]);

    return {
        handleClick,
    };
};
